module.exports = __webpack_public_path__ + "static/media/profile-image.3e0a5f98.png";